import { Table } from '@zillow/constellation-10';
import { LoadingText } from '@zg-rentals/loading-components';

export const TasksTableSkeleton = () => {
  return (
    <>
      <Table.Header>
        <Table.Row>
          {Array.from({ length: 6 }).map((_, idx) => (
            <Table.HeaderCell key={idx}>
              <LoadingText isLoading={true} loadingWidth="60%" textStyle="body-bold">
                Loading
              </LoadingText>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Array.from({ length: 5 }).map((_, idx) => {
          return (
            <Table.Row css={{ verticalAlign: 'middle' }} key={`loading-row-${idx}`}>
              {Array.from({ length: 6 }).map((_, idx) => (
                <Table.Cell key={idx}>
                  <LoadingText isLoading={true} loadingWidth="100%" textStyle="body">
                    Loading
                  </LoadingText>
                </Table.Cell>
              ))}
            </Table.Row>
          );
        })}
      </Table.Body>
    </>
  );
};
